import { HeroFieldsFragment } from "@src/generated/graphql";
import { highlightUnderscoreText } from "src/utils/utils";
import { FaArrowRightLong } from "react-icons/fa6";
import { DynamicLink, ImageWrapper, Typography } from "src/components/shared";

type HeroComponentProps = {
  content: HeroFieldsFragment;
};

const PartnerHero = ({ content }: HeroComponentProps) => {
  const {
    title,
    heroFieldDescriptionJson,
    heroImage,
    primaryButton,
    secondaryButton,
    backgroundImage,
  } = content;
  const descriptionText =
    heroFieldDescriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? "";

  return (
    <div className="hero-block">
      <div
        className="hero-banner-block hero-background partner-hero"
       >
        <img
          src={backgroundImage?.url ?? ""}
          alt="background"
          className="background-image"
        />
        <div className="hero-gradient-overlay"></div>

        <div className="container-fluid custom-spacer-col position-relative gap-5">
          <div className="hero-content-wrapper partner-hero-content-wrapper" >
            <h1
              className="hero-title  hero-title-custom  partner-title light"
              dangerouslySetInnerHTML={{
                __html: highlightUnderscoreText(title ?? ""),
              }}
            />
            {descriptionText && (
              <Typography
                tag="p"
                className="hero-description text-center partnership-page light "
              >
                {descriptionText}
              </Typography>
            )}
            <div className="partner-button">
              {primaryButton && (
                <DynamicLink
                  url={primaryButton.buttonLink ?? ""}
                  className="btn-white"
                >
                  <span>{primaryButton.buttonText ?? ""}</span>
                  <FaArrowRightLong className="btn-icon" />
                </DynamicLink>
              )}
              {secondaryButton && (
                <DynamicLink
                  url={secondaryButton.buttonLink ?? ""}
                  className="btn-transparent"
                >
                  <span>{secondaryButton.buttonText ?? ""}</span>
                  <FaArrowRightLong className="btn-icon" />
                </DynamicLink>
              )}
            </div>
          </div>
        </div>
        <div className="hero-image-position">
          {heroImage?.url && (
            <ImageWrapper
              src={heroImage.url ?? ""}
              alt={heroImage.title ?? ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnerHero;
